module.exports = __webpack_public_path__ + "static/fbflogo.e7668ae6.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/fbflogo.png
// module id = 268
// module chunks = 0